import React, { useState } from 'react';
import { apiGet } from '../../../utils/api';
import { getConfig } from '../../../utils/config';

function DataSettings() {
    const [dataExportFormat, setDataExportFormat] = useState('json');
    const [exporting, setExporting] = useState(false);
    const [error, setError] = useState('');

    const handleExport = async () => {
        setExporting(true);
        setError('');

        try {
            const response = await apiGet(`/profile/export?format=${dataExportFormat}`);

            if (!response.ok) {
                throw new Error('Export failed');
            }

            if (dataExportFormat === 'csv') {
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `jpro_export_${new Date().toISOString().slice(0, 10)}.csv`;
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
            } else {
                const data = await response.json();
                const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `jpro_export_${new Date().toISOString().slice(0, 10)}.json`;
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
            }
        } catch (err) {
            console.error('Export error:', err);
            setError('Failed to export data. Please try again.');
        } finally {
            setExporting(false);
        }
    };

    return (
        <div className="space-y-6">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 shadow-sm border border-gray-200 dark:border-gray-700">
                <h2 className="text-xl font-dm-serif font-semibold mb-4">Data Management</h2>

                <div className="space-y-6">
                    <div>
                        <h3 className="font-unna font-medium mb-2">Export Your Data</h3>
                        <p className="text-sm text-gray-500 dark:text-gray-400 font-rasa mb-4">
                            Download your profile, conversations, documents, and projects
                        </p>

                        {error && (
                            <p className="text-sm text-red-500 mb-3">{error}</p>
                        )}

                        <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                            <select
                                value={dataExportFormat}
                                onChange={(e) => setDataExportFormat(e.target.value)}
                                className="px-3 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white font-rasa"
                            >
                                <option value="json">JSON Format</option>
                                <option value="csv">CSV Format</option>
                            </select>

                            <button
                                onClick={handleExport}
                                disabled={exporting}
                                className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors font-rasa disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                {exporting ? 'Exporting...' : 'Export Data'}
                            </button>
                        </div>
                    </div>

                    <div className="border-t border-gray-200 dark:border-gray-700 pt-6">
                        <h3 className="font-unna font-medium mb-2 text-red-600 dark:text-red-400">Delete Account</h3>
                        <p className="text-sm text-gray-500 dark:text-gray-400 font-rasa mb-4">
                            Permanently delete your account and all associated data. This action cannot be undone.
                        </p>

                        <button className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors font-rasa opacity-50 cursor-not-allowed" disabled>
                            Delete Account
                        </button>
                        <p className="text-xs text-gray-400 mt-2 font-rasa">Contact an administrator to delete your account.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DataSettings;
